import { Routes } from '@angular/router';

export const HELP_ROUTES: Routes = [
	{
		path: 'help',
		loadComponent: () => import('./feature-help/help').then((m) => m.Help),
		data: { title: 'Ajuda' },
	},
	{
		path: 'help/:topic',
		loadComponent: () => import('./feature-help/help').then((m) => m.Help),
		data: { title: 'Ajuda' },
	},
];
